/**
 * The pounce charge meter: one fixed element (#charge in index.html) driven
 * entirely through CSS -- an `on` class for visibility, a `ready` class for
 * the full-charge state, and a `--charge` custom property that feeds a
 * scaleX() on the fill.  set() runs every frame from the render loop, so the
 * budget is a couple of cached comparisons on idle frames and, while actually
 * charging, one style-property write that only ever moves a transform --
 * never layout, never DOM structure.
 */
export class ChargeMeter {
  constructor(el) {
    this.el = el;
    this.label = el.querySelector("span");
    this.on = false;
    this.ready = false;
    this.shown = -1; // last --charge written
  }

  /** charge 0..1, charging bool.  Called every frame; no-ops when idle. */
  set(charge, charging) {
    if (charging) {
      // Quantised to 1/100: on the 166px track that is under 2px, below
      // notice, and it stops the writes entirely once a full charge is just
      // being held (the common case -- lining up a big pounce).
      const step = Math.min(100, Math.round(charge * 100)) / 100;
      if (step !== this.shown) {
        this.shown = step;
        this.el.style.setProperty("--charge", step);
      }
      const ready = step >= 1;
      if (ready !== this.ready) {
        this.ready = ready;
        this.el.classList.toggle("ready", ready);
        // The label flips with the colour because under
        // prefers-reduced-motion the throb is gone and the word is most of
        // the ready signal.  Edge-triggered, so never a per-frame DOM write.
        this.label.textContent = ready ? "ready" : "pounce";
      }
    }
    // After a release the fill and the ready colour are left frozen while
    // the meter falls away: zeroing the bar mid-fade reads as a glitch, and
    // the next charge overwrites both on its first frame, behind the fade-in.
    if (charging !== this.on) {
      this.on = charging;
      this.el.classList.toggle("on", charging);
    }
  }
}
